module.exports = __webpack_public_path__ + "static/media/recorrido15k.691c9e54.webp";